import { useRouter } from 'next/router';
import { useEffect } from 'react';

import ErrorStatusPage from 'components/ErrorStatus';
import Page from 'components/Page';
import Layout from 'components/layouts/Layout';

import { logger } from 'lib/logger';

export default function FourOhFourPage() {
  const router = useRouter();

  useEffect(() => {
    logger.error(`404 on ${router.asPath}`);
  }, []);

  return (
    <Layout backgroundColor="$black100">
      <Page absolute headerMode="DARK" title="Page not found" noFooter>
        <ErrorStatusPage code={404} />
      </Page>
    </Layout>
  );
}
